import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import {
  getCurrentUrl,
  getTabIdFromNonTabPage,
} from '../../features/navigation/operations';

export function useTabId(): string | undefined {
  const tabId = pages.tabs.useMatch()?.params?.tabId as string | undefined;
  if (tabId) return tabId;

  return getTabIdFromNonTabPage(getCurrentUrl());
}
